import { useEffect, useState } from 'react'
import { AdminType } from './AdminList'
import { TextInputDefault } from '@components/form/TextInput';
import SelectInput from '@components/form/SelectInput';
import { accountStatusOptions, roleOptions } from '@static/data';
import Notification from '@components/common/Notification';
import Loading from '@components/common/Loading';
import { NotificationType } from 'react-app-env';
import { validateAddAdmin } from '@redux/validations/admins';
import axios, { AxiosResponse } from 'axios';
import { API_URL } from '@redux/api';

type ErrorsType = {
  name?: string;
  phone?: string;
  email?: string;
  role?: string;
  status?: string;
};

const EditAdminForm = ({
  data,
  onClose
}: {
  data: AdminType | null;
  onClose: () => void;
}) => {
  
  const [id, setId] = useState<string | undefined>("");
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [role, setRole] = useState<any>(null);
  const [status, setStatus] = useState<any>({
    label: "Aktif",
    value: true
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notification, setNotification] = useState<NotificationType | null>(null);
  const [errors, setErrors] = useState<ErrorsType>({});

  useEffect(() => {
    if(data) {
      const { _id, name, email, phone, role, isActive } = data;

      const statusValue = {
        value: isActive,
        label: isActive ? "Aktif" : "Non-aktif"
      };

      const roleValue = roleOptions.find(e => e.value === role);

      setId(_id);
      setName(name);
      setEmail(email);
      setPhone(phone);
      setRole(roleValue);
      setStatus(statusValue);
    };

    return () => {}
  }, [data]);

  const isValidForm = (data: AdminType) => {
    const { errors, isValid } = validateAddAdmin(data);
    if (!isValid) {
      setErrors(errors);
    }
    return isValid;
  };

  const onSubmit = async(e: any) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({});
    setNotification(null);

    const payload = {
      _id: id,
      name,
      email,
      phone,
      role,
      isActive: status.value
    };

    if(isValidForm(payload)) {
      const dataToSubmit = {
        ...payload,
        role: role.value,
      };

      const response: AxiosResponse = await axios.post(`${API_URL}/admin/edit`, dataToSubmit);
      const { status } = response;

      if(status === 200) {
        setIsLoading(false);
        setNotification({
          isError: false,
          title: "Sukses!",
          text: "Data admin berhasil di ubah",
        });

        setTimeout(() => {
          setNotification(null);
          onClose();
        }, 3000);
      } else {
        setIsLoading(false);
        setNotification({
          isError: true,
          title: "Data tidak lengkap",
          text: "Mohon lengkapi formulir di atas",
        });
      };
    } else {
      setIsLoading(false);
      setNotification({
        isError: true,
        title: "Data tidak lengkap",
        text: "Mohon lengkapi formulir di atas",
      });
    };
  };

  return (
    <form>
      <div className="mt-4">
        <TextInputDefault
          name="name"
          label="Nama"
          value={name}
          placeholder="Masukkan nama admin"
          onChange={({ target }) => {
            setErrors({
              ...errors,
              [target.name]: null,
            });
            setName(target.value);
          }}
          disabled={isLoading}
          error={errors.name}
        />
      </div>
      <div className="mt-4">
        <TextInputDefault
          name="email"
          label="Email"
          value={email}
          placeholder="Masukkan email"
          onChange={({ target }) => {
            setErrors({
              ...errors,
              [target.name]: null,
            });
            setEmail(target.value);
          }}
          disabled={isLoading}
          error={errors.email}
        />
      </div>
      <div className="mt-4">
        <TextInputDefault
          name="phone"
          label="No. HP"
          value={phone}
          placeholder="Masukkan no. hp"
          onChange={({ target }) => {
            setErrors({
              ...errors,
              [target.name]: null,
            });
            setPhone(target.value);
          }}
          disabled={isLoading}
          error={errors.phone}
        />
      </div>
      <div className="mt-4">
        <SelectInput
          isMulti={false}
          label='Jabatan'
          placeholder="Pilih jabatan"
          disabled={isLoading}
          options={roleOptions}
          value={role}
          error={errors?.role}
          onChange={(value) => {
            setErrors({
              ...errors,
              role: undefined,
            })
            setRole(value)
          }}
        />
      </div>
      <div className="mt-4">
        <SelectInput
          isMulti={false}
          label='Status'
          placeholder="Pilih status admin"
          disabled={isLoading}
          options={accountStatusOptions}
          value={status}
          error={errors?.status}
          onChange={(value) => setStatus(value)}
        />
      </div>
      <div className="mt-4">
        <Notification notification={notification} />
      </div>
      <div className="mt-8">
        {isLoading ?
          <div>
            <Loading loading={isLoading} type='beat-loader' size={10} parentClass='text-sm' />
          </div>
          : <button
            type='submit'
            onClick={onSubmit}
            className='w-full justify-center bg-orange-600 text-white rounded-lg py-3 font-semibold'
          >
            Simpan
          </button>
        }
      </div>
    </form>
  )
}

export default EditAdminForm